<template>
<article v-if="grouping" class="info-section elr-container-full">
  <div class="form-wrapper">
    <div class="info-section-header">
      <InfoSectionHeading>Add Pony to {{grouping.name}}</InfoSectionHeading>
        <div class="button-holder button-holder-left">
          <router-link
            to="/ponies"
            class="elr-button elr-button-primary"
          >See All Ponies</router-link>
        </div>
    </div>
    <div>
      <div v-if="role && role.id <= 1">
        <Spinner v-if="status === 'loading'" key="spinner" />
        <div v-if="status === 'success'">
          <p class="success-message">Success!</p>
          <div class="created-item">
            <router-link :to="`/ponies/${latest.id}`">View New Pony</router-link>
          </div>
        </div>
        <FormPonyCreate
          v-if="grouping.id"
          :groupId="grouping.id"
        />
      </div>
      <div v-else>
        <h2 class="info-section-subheading">You are not authorized to create new ponies.</h2>
      </div>
    </div>
  </div>
</article>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import FormPonyCreate from '../../components/FormPonyCreate/FormPonyCreate';
import InfoSectionHeading from '../../components/InfoSectionHeading/InfoSectionHeading';
import Spinner from '../../components/Spinner/Spinner';

export default {
  name: 'PonyCreate',
  props: {
    id: {
      type: String,
      required: true
    },
  },
  mounted() {
    this.$store.dispatch('grouping/FETCH', {
      id: this.id,
      num: 6
    });
  },
  components: {
    FormPonyCreate,
    InfoSectionHeading,
    Spinner
  },
  computed: {
    ...mapState({
      role: state => state.currentUser.role
    }),
    ...mapGetters('pony', { ponies: 'getAll' }),
    ...mapState('pony', ['status']),
    latest() {
      return this.ponies[this.ponies.length - 1];
    },
    grouping() {
      const grouping = this.$store.getters['grouping/getById'](this.id)

      if (grouping) {
        return grouping;
      }

      return {};
    }
  },
  created() {
    this.RESET_ERRORS();
    this.RESET_STATUS();
  },
  methods: {
    ...mapActions('pony', ['RESET_ERRORS', 'RESET_STATUS']),
  },
  watch: {
    $route() {
      this.RESET_ERRORS();
    }
  }
};
</script>
